import { styled } from 'solid-styled-components';
import { theme, palette, fontFamilyAtosRegular, fontFamilyAtosBold } from '../../style/theme';
import { Link } from '@solidjs/router';

const { spacing } = theme;

export const StyledBlogAndNewsOuter = styled.div``;

export const StyledBlogAndNews = styled.article`
    position: relative;
    background-color: white;
    border-radius: 1.43rem;
    padding: ${spacing.xl} ${spacing.m} ${spacing.ms} ${spacing.m};
    margin: ${spacing.xs} 0;

    ${theme.mediaQueries.mobileMax} {
        padding: ${spacing.s} ${spacing.xxs};
    }
`;

export const StyledMetaInfo = styled.div`
    display: flex;
    flex-direction: row;
    gap: 6rem;
    font-family: ${fontFamilyAtosBold}; 
    font-weight: 800;
    font-size: 1.29rem;
    color: ${theme.palette.darkGray};
`;

export const StyledDate = styled.div`
    display:flex;
    flex-direction: row;
    gap: 1rem;
`;

export const StyledBlogWrapper = styled.div<{ adjustForHcpHeader: boolean }>`
    container-type: inline-size;
    overflow-x: hidden;
    @media print {
        display: none;
    }

    ${p => p.adjustForHcpHeader ? `
        ${theme.mediaQueries.desktopMin} {
            margin-top: 8rem;
        }
            
        margin-top: 6rem;
    ` : ''}
`;

export const StyledDateText = styled.div`
    
`;

export const StyledAuthor = styled.div`
    
`;

// I put static height so that event card and related events card are aligned horisontally
export const StyledBreadCrumbsWrapper = styled.div`
    color: ${palette.gray};
    font-family: ${fontFamilyAtosRegular};
    font-size: 1.64rem;
    padding-top: 1rem;
    display: flex;
    gap: 0.5rem;
`;

export const StyledLink = styled(Link)`
    height: max-content;
    color: ${palette.gray};
    &:hover {
        color: ${theme.palette.pink};
    }
`;

export const StyledCurrentPage = styled.div`
    color: ${palette.red};
`;
